/**
 * Do not edit directly
 * Generated on Wed, 26 Jul 2023 10:01:18 GMT
 */

export const typography = {
  fontFamilies: {
    inter: 'Inter',
    ibmplexmono: 'IBM Plex Mono',
  },
  lineHeights: {
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem',
    '11': '2.75rem',
    '12': '3rem',
    '13': '3.25rem',
    '14': '3.5rem',
    '15': '3.75rem',
    '16': '4rem',
    '17': '4.25rem',
    '18': '4.5rem',
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  fontSize: {
    '2xs': '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.75rem',
    '4xl': '2rem',
    '5xl': '2.25rem',
    '6xl': '2.5rem',
    '7xl': '2.75rem',
    '8xl': '3rem',
    '9xl': '3.5rem',
    '10xl': '4rem',
    '11xl': '4.5rem',
  },
  letterSpacing: {
    '1': '-0.006em',
    '2': '-0.014em',
    '3': '-0.019em',
    '4': '-0.022em',
    wide: '0.080em',
    normal: 0,
  },
  paragraphSpacing: {
    '0': 0,
  },
}
